import { PageSwitcherTypes } from '@app/router';

const navigateToBrowsePageWithFilters = (
  pathname: string,
  search: string,
  history: Record<string, any>,
  buildUrl: (urlPrefix: string) => string,
) => {
  const parts: string[] = pathname.split('/');

  // Extract current vertical route (ex. 'accessories/backpack'). If not available, default to /sneakers.
  const resetUrlRoute = buildUrl(
    `${
      parts.length > 2 ? parts.splice(2, parts.length).join('/') : 'sneakers'
    }`,
  );

  const searchParams = new URLSearchParams(search); // Get current search params
  searchParams.delete('s'); // Remove search string from params
  const searchStringToAppend = searchParams.toString();
  history.push(
    buildUrl(
      // Head to browse page with current search params
      `${resetUrlRoute}${
        searchStringToAppend.length ? `?${searchStringToAppend}` : ''
      }`,
    ),
    {
      as: PageSwitcherTypes.Browse,
      from: pathname,
    },
  );
};

export default navigateToBrowsePageWithFilters;
